var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A545E",
    fillRule: "evenodd",
    d: "M9 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m9.25-3.25A.75.75 0 0 1 15 3a4 4 0 0 1 0 8 .75.75 0 0 1 0-1.5 2.5 2.5 0 0 0 0-5 .75.75 0 0 1-.75-.75M3 18.625A5.625 5.625 0 0 1 8.625 13h.75A5.625 5.625 0 0 1 15 18.625 2.375 2.375 0 0 1 12.625 21h-7.25A2.375 2.375 0 0 1 3 18.625M8.625 14.5A4.125 4.125 0 0 0 4.5 18.625c0 .483.392.875.875.875h7.25a.875.875 0 0 0 .875-.875A4.125 4.125 0 0 0 9.375 14.5zm5.875-.75a.75.75 0 0 1 .75-.75h.125A5.625 5.625 0 0 1 21 18.625 2.375 2.375 0 0 1 18.625 21H17a.75.75 0 0 1 0-1.5h1.625a.875.875 0 0 0 .875-.875 4.125 4.125 0 0 0-4.125-4.125h-.125a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgUsers;